module.exports = __webpack_public_path__ + "img/google.53e52bc.png";